<template>
  <ion-item :detail="false" button class="list-item" @click="selectLogo">
    <template v-if="props.logo">
      <ion-radio slot="start" :value="props.logo.id"></ion-radio>
      <ApiIcon
        slot="start"
        :type="props.logo.type"
        :name="props.logo.name"
        :iconStyle="props.logo.style"
      ></ApiIcon>
      <ion-label class="ion-text-wrap">
        <h2>
          {{ props.logo.name }}
          <ion-note>{{ props.logo.type }}</ion-note>
        </h2>
        <p>
          {{ props.logo.style }}
        </p>
      </ion-label>
    </template>
    <ApiIcon v-else slot="start"></ApiIcon>
  </ion-item>
</template>

<script setup lang="ts">
import { IonItem, IonLabel, IonNote, IonRadio } from "@ionic/vue";
import { defineComponent } from "vue";
import type { FontAwesomeIcon } from "@/models/api";
import ApiIcon from "@/components/ApiIcon.vue";
import { iconObjectToIconString, type IconString } from "@/helper/icons";

defineComponent({
  name: "ChooseIconListElement",
});

const props = defineProps<{
  logo: FontAwesomeIcon | null;
}>();
const emit = defineEmits<{
  (e: "select", value: IconString): void;
}>();

function selectLogo() {
  if (props.logo) {
    emit("select", iconObjectToIconString(props.logo));
  }
}
</script>

<style scoped></style>
